import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchEvaluationData = createAsyncThunk(
    'evaluation/fetchData',
    async (tenderId, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/evaluation/${tenderId}`
            );
            return response.data; 
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data || { message: error.message });
            } else if (error.request) {
                return rejectWithValue({ message: 'Tidak ada respon dari server' });
            } else {
                return rejectWithValue({ message: error.message });
            }
        }
    }
);

export const fetchEvaluationCriteria = createAsyncThunk(
    'evaluation/fetchCriteria',
    async (_, { rejectWithValue }) => {  
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/vendor/evaluation-criteria`
            );
            const { quantitative = [], qualitative = [] } = response.data;

            const combined = [
                ...quantitative.map(item => ({ ...item, evaluation_type: 'quantitative' })),
                ...qualitative.map(item => ({ ...item, evaluation_type: 'qualitative' })),
            ];
            return combined;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Submit evaluasi
export const submitEvaluation = createAsyncThunk(
    'evaluation/submit',
    async ({ tenderId, quantitative, qualitative, files }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('tender_id', tenderId);
            formData.append('quantitative', JSON.stringify(quantitative)); // { criteriaId: score }
            formData.append('qualitative', JSON.stringify(qualitative)); // { criteriaId: { comments } }

            // Lampirkan file untuk setiap kriteria kualitatif
            /*if (files) {
                Object.keys(files).forEach((key) => {
                    formData.append(`attachments[${key}]`, files[key]);
                });
            }*/

            const response = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/vendor/evaluation_submit`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data;
        } catch (error) {
            // Ambil data error dari response
            if (error.response) {
                return rejectWithValue(error.response.data);
            } else if (error.request) {
                return rejectWithValue({ message: 'Tidak ada respon dari server' });
            } else {
                return rejectWithValue({ message: error.message });
            }
        }
    }
);